import { render } from "./DisplayTitlePageNode.vue?vue&type=template&id=b6f3f786"
import script from "./DisplayTitlePageNode.vue?vue&type=script&lang=js"
export * from "./DisplayTitlePageNode.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__